export enum RetailLocationsProductCatalogueWorkspaceCapabilityAccessOperation {
    read = "64a605ba-610f-4e48-9e14-f560959a591f",
    update = "e5c8a2ed-819a-4742-af8e-9ebf6b70b1af",
}
